import axios from 'axios';
// import Vue from 'vue';
// import VueToast from 'vue-toast-notification';
// import 'vue-toast-notification/dist/theme-sugar.css';

// Use the VueToast plugin
// Vue.use(VueToast);

// Add a request interceptor to attach the token to outgoing requests
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    // Attach the token to the headers
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Add a response interceptor to handle expired tokens
axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.response.status === 401) {
    // Handle unauthorized (token expired) response here
    // Show a toast message using VueToast
    // Vue.$toast.error('Session expired. Please log in again.');
    this.$toaster.warning("Session expired. Please log in again. ", {
      timeout: 5000,
    });
  }
  return Promise.reject(error);
});